import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import Button from '../../_atomic/Button/Button';

class DeleteUserSuccessModule extends Component {
    static propTypes = {
      visible: PropTypes.bool.isRequired,
      disableModal: PropTypes.func.isRequired,
      toggleDeleteUser: PropTypes.func.isRequired,
      userId: PropTypes.number.isRequired,
      userName: PropTypes.string.isRequired,
    };

    render() {
      const {
        visible,
        disableModal,
        toggleDeleteUser,
        userId,
        userName,
      } = this.props;

      return (
        <Modal
          visible={visible}
          requestClose={this.requestClose}
          className="upload-media-modal"
        >
          <div className="delete-user-modal">
            <div className="sections-wrapper">
              <div className="select-wrapper">
                <div className="main-label-no-transform">
                  <span>Delete User</span>
                </div>
                <div style={{ fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>
                  <span> Are you sure want to delete user {userName}? </span>
                </div>
                <div className="button-wrapper" style={{ paddingBottom: '25px', marginTop: '15px' }}>
                  <Button type="submit" label="Yes" clickHandler={() => toggleDeleteUser(userId)} />
                  <Button type="submit" label="Close" clickHandler={() => disableModal(false)} />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      );
    }
}

export default DeleteUserSuccessModule;



// WEBPACK FOOTER //
// ./src/components/_molecules/DeleteUserSuccessModule/DeleteUserSuccessModule.js